import { http } from '@/api/http';
import { ApiResponseBody } from '@/api/types';
import {
  ReleaseNote,
  ReleaseNotesResponse,
  ReleaseNotesQueryParams,
  CreateReleaseNotePayload,
  UpdateReleaseNotePayload,
} from '@/api/apis/release-notes';
import { getOpobffReleaseNotesApiUrl } from './opobff-release-notes.paths';

const getReleaseNotes = async (params?: ReleaseNotesQueryParams): Promise<ReleaseNotesResponse> => {
  const res = await http.get<ApiResponseBody<ReleaseNotesResponse>>(getOpobffReleaseNotesApiUrl.list(), { params });
  return res.data.data;
};

const createReleaseNote = async (body: CreateReleaseNotePayload): Promise<ReleaseNote> => {
  const res = await http.post<ApiResponseBody<ReleaseNote>>(getOpobffReleaseNotesApiUrl.list(), body);
  return res.data.data;
};

const updateReleaseNote = async (releaseNoteId: string, body: UpdateReleaseNotePayload): Promise<ReleaseNote> => {
  const res = await http.put<ApiResponseBody<ReleaseNote>>(getOpobffReleaseNotesApiUrl.byId(releaseNoteId), body);
  return res.data.data;
};

const deleteReleaseNote = async (releaseNoteId: string): Promise<void> => {
  await http.delete(getOpobffReleaseNotesApiUrl.byId(releaseNoteId));
};

export const opobffReleaseNotesApiFetcher = {
  getReleaseNotes,
  createReleaseNote,
  updateReleaseNote,
  deleteReleaseNote,
};
